import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCreateSpaceKey, getCollectionsKey, getSpaceKey, getMemberNotificationSettingsKey, } from '../../utils/keys';
export const useCreateSpace = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const createSpaceKey = getCreateSpaceKey();
    const collectionsKey = getCollectionsKey({});
    return useMutation((input) => client.spaces.create(input, fields), {
        mutationKey: createSpaceKey,
        onSuccess: async (space) => {
            const spaceKey = getSpaceKey({ id: space.id });
            queryClient.setQueryData(spaceKey, _ => space);
            queryClient.invalidateQueries(getMemberNotificationSettingsKey());
            queryClient.invalidateQueries(spaceKey);
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateSpace.js.map